import { Action } from '@ngrx/store';

export enum SpecialInvoiceActionTypes {
  SET_SPECIAL_INVOICE = '[Special Invoice] Set special invoice',
  RESET = '[Special Invoice] Reset',
}

export class SetSpecialInvoiceAction implements Action {
  readonly type = SpecialInvoiceActionTypes.SET_SPECIAL_INVOICE;

  constructor(public payload: boolean) {}
}

export class SpecialInvoiceResetAction implements Action {
  readonly type = SpecialInvoiceActionTypes.RESET;

  constructor() {}
}

export type SpecialInvoiceActions = SetSpecialInvoiceAction | SpecialInvoiceResetAction;
